export default __webpack_public_path__ + "static/media/compost-1point-5-to-1.8e4f358c.jpg";